import { render, staticRenderFns } from "./ManagementSurveyEdit.vue?vue&type=template&id=4b8c20da&"
import script from "./ManagementSurveyEdit.vue?vue&type=script&lang=js&"
export * from "./ManagementSurveyEdit.vue?vue&type=script&lang=js&"
import style0 from "./ManagementSurveyEdit.vue?vue&type=style&index=0&lang=css&"
import style1 from "@/assets/styles/themes/default/management.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports